export enum ProfessionSort {
  Name = 1
}